import React from 'react';
import { motion } from 'framer-motion';
import { Unlock, Zap, Eye, Code, Power } from 'lucide-react';
export function Benefits() {
  const benefits = [{
    icon: <Code size={24} data-id="element-12" />,
    text: 'Identificar pensamientos y creencias que frenan tu evolución.'
  }, {
    icon: <Unlock size={24} data-id="element-13" />,
    text: 'Abrirte a nuevas posibilidades de crecimiento interior.'
  }, {
    icon: <Zap size={24} data-id="element-14" />,
    text: 'A ver tu vida desde una perspectiva más consciente.'
  }, {
    icon: <Power size={24} data-id="element-15" />,
    text: 'Iniciar un proceso de reflexión profunda y transformación.'
  }, {
    icon: <Eye size={24} data-id="element-16" />,
    text: 'Reconectar con tu verdad, tu armonía y tu equilibrio'
  }];
  return <section className="py-16 md:py-24 bg-matrix-dark relative px-4 border-y border-matrix-green/10" data-id="element-17">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="font-cinzel text-3xl md:text-5xl text-center text-matrix-cream mb-10 md:mb-16" data-id="element-19">
          Al leer este libro, aprenderás a:
        </motion.h2>

        <div className="space-y-4 md:space-y-6" data-id="element-20">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center gap-4 md:gap-6 bg-matrix-black/50 p-4 md:p-6 rounded-lg border border-matrix-green/10 hover:border-matrix-green/40 transition-colors" data-id="element-21">
              <div className="text-matrix-green bg-matrix-green/10 p-2 md:p-3 rounded-md shrink-0" data-id="element-22">
                {benefit.icon}
              </div>
              <p className="text-matrix-white text-base md:text-xl font-light" data-id="element-23">
                {benefit.text}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}